module.exports = __webpack_public_path__ + "static/media/2.Mini Atta Chakki.66a1ec14.jpg";